import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ApiCisternResponseDto } from '@birco/rainmesh-api';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { LocalizedNumberPipe } from '../../../../shared/pipes/localized-number.pipe';
import { LocalizedPercentPipe } from '../../../../shared/pipes/localized-percent.pipe';
import { IconComponent } from '../../../../shared/icons/icon.component';
import {
  ContextMenuComponent,
  ContextMenuData,
} from '../../../../shared/components/context-menu/context-menu.component';
import { Router } from '@angular/router';
import { RouteConstants } from '../../../../shared/constants/route-constants';
import { MatDialog } from '@angular/material/dialog';
import {
  ConfirmDialogComponent,
  ConfirmDialogData,
} from '../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { filter } from 'rxjs';

@Component({
  selector: 'tr[app-cistern-item-row]',
  imports: [
    TranslatePipe,
    LocalizedNumberPipe,
    LocalizedPercentPipe,
    IconComponent,
    ContextMenuComponent,
  ],
  templateUrl: './cistern-item-row.component.html',
  styleUrl: './cistern-item-row.component.scss',
})
export class CisternItemRowComponent {
  private dialog = inject(MatDialog);
  private router = inject(Router);
  private translateService = inject(TranslateService);

  @Input() isHeader = false;
  @Input() cistern?: ApiCisternResponseDto;
  @Output() delete = new EventEmitter<string>();
  @Output() edit = new EventEmitter<string>();

  contextMenu: ContextMenuData[] = [
    {
      labelKey: 'default.details',
      action: () =>
        this.router.navigate([RouteConstants.routeCistern, this.cistern?.id]),
    },
    {
      labelKey: 'default.edit',
      action: () => this.edit.emit(this.cistern?.id),
    },
    {
      labelKey: 'default.delete',
      action: () => this.onDelete(),
    },
  ];

  onDelete(): void {
    const dialogData: ConfirmDialogData = {
      title: this.translateService.instant('cisterns.delete.title'),
      body: this.translateService.instant('cisterns.delete.body'),
      confirmLabel: this.translateService.instant('default.delete'),
    };

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: dialogData,
    });

    dialogRef
      .afterClosed()
      .pipe(filter((result): result is true => result === true))
      .subscribe((_) => {
        this.delete.emit(this.cistern?.id);
      });
  }
}
